import {
  Component,
  OnInit,
  PLATFORM_ID,
  Inject,
  AfterViewInit,
  Renderer2
} from '@angular/core'
import { isPlatformBrowser, DOCUMENT } from '@angular/common'
import { Title, Meta } from '@angular/platform-browser'
import { LinkService } from '../../_services/langhfre.service'
import { MatDialog } from '@angular/material/dialog'
import { AiContentFeedbackModalComponent } from 'src/app/Components/ai-content-feedback-modal/ai-content-feedback-modal.component'
import { DetectionLimitExhaustModalComponent } from '../detection-limit-exhaust-modal/detection-limit-exhaust-modal.component'
import { ToastrService } from 'ngx-toastr';
import { WebsiteService } from 'src/app/_services/website.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { NoopScrollStrategy } from '@angular/cdk/overlay'
import * as $ from 'jquery'
import { Router } from '@angular/router';
import { LoadScriptService } from 'src/app/_services/load-script.service';
declare const fpPromise: any;
@Component({
  selector: 'app-ai-detector-tool',
  templateUrl: './ai-detector-tool.component.html',
  styleUrls: ['./ai-detector-tool.component.scss']
})
export class AiDetectorToolComponent implements OnInit {
  inputWordCount: number = 0
  inputText: string = ''
  showWordLimitErr: boolean = false
  wordLimitErrHeading: string = ''
  wordLimitErrMsg: string = ''
  usersCurrentAvailableSessionCount: number = -1
  isSubmitBtnDisabled: boolean = false
  isAIContent: boolean = false
  aiContentScore: number = 0
  humanContentScore: number = 0
  showLoadingState: boolean = false
  showErrorModal: boolean = false
  setUserId: string = null
  contentDetectorLimit: number = 500
  aboveLimitText: string = ''
  isLimitExhausted: boolean = false;
  contactForm: FormGroup;
  formSection: boolean = true;
  thankSection: boolean = false;
  country: string;
  apiResponse: any = undefined;

  constructor (
    private _dialog: MatDialog,
    private _appService: WebsiteService,
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private router: Router,
    public loadScript: LoadScriptService
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle("AI 콘텐츠 탐지기| AI 생성 콘텐츠 식별 | Trinka");
    this.metaTagService.updateTag({ name: 'description', content: "Trinka AI 탐지기는 ChatGPT, GPT-4, Bard, Bing Chat 등으로 생성된 콘텐츠를 식별하는 AI 콘텐츠 탐지 도구입니다." });
    this.metaTagService.updateTag({ property: 'og:title', content: "AI 콘텐츠 탐지기| AI 생성 콘텐츠 식별 | Trinka" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinka AI 탐지기는 ChatGPT, GPT-4, Bard, Bing Chat 등으로 생성된 콘텐츠를 식별하는 AI 콘텐츠 탐지 도구입니다." });
    this.metaTagService.updateTag({ name: 'keywords', content: 'ai content detector, ai content detection, ai content detectors, ai contect detector, chatgpt detector, ai text detector, free ai detector, ai content detector free, ai detector for essays, ai content detection tool, best ai content detector, ai written text detector, ai generated text detector, ai content detector tools' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/ai-content-detector' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/ai-content-detector' });
    this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/ai-content-detector' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/ai-content-detector' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/ai-content-detector' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/ai-content-detector' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/ai-content-detector' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/ai-content-detector' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/ai-content-detector' });
    this.generateAndSetUserId();
    if(this.setUserId) this.getUserSessionCount();
    this._attachKeydownEventListener(document.getElementById('inputEditor'))
    this.attachPasteEventListener(document.getElementById('inputEditor'))
    if (isPlatformBrowser(this.platformId)) {
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      // document.getElementById('main_header').classList.add('homepageHeader');
      $.getScript('../../../assets/js/hubslider.js', function () {})
      $.getScript('../../../assets/js/owl.carousel.min.js', function () {})
      $.getScript('../../../assets/js/wisepop.js', function () {})
      $.getScript('../../../assets/js/home_client_slider.js', function () {})
    }
  }

  onInputEditorChange (txt: string) {
    this._updateCounts(txt)
    this.resetScoreAndInputText()
    if (this.inputWordCount <= 500 && this.isSubmitBtnDisabled) {
      this.isSubmitBtnDisabled = false
    }
  }

  private _wordCount (text) {
    return text.split(/(\s+)/).filter(x => x.trim().length > 0).length
  }

  _updateCounts (txt: string) {
    this.inputText = txt
    this.inputWordCount = this._wordCount(txt.trim())
  }

  openFeedbackModal (likeFlag: boolean): void {
    try {
      const dialogRef = this._dialog.open(AiContentFeedbackModalComponent, {
        width: '500px',
        height: 'auto',
        disableClose: true,
        backdropClass: 'custom-dialog-background',
        panelClass: "border-radius16",
        data: {
          isLiked: likeFlag,
          inputText: this.inputText,
          userID: this.setUserId,
          apiResponse: this.apiResponse
        },
        scrollStrategy: new NoopScrollStrategy()
      })

      dialogRef.afterClosed().subscribe(result => {
      })
    } catch (e) {
      console.log('Err is: ', e)
    }
  }

  clearEditors (): void {
    this.inputWordCount = 0
    document.getElementById('inputEditor').innerHTML = ''
    this.resetScoreAndInputText()
  }

  sendTextForAIDetection() {
    this.generateAndSetUserId();
    if (this.inputWordCount < 100) {
      this.showWordLimitErr = true
      this.wordLimitErrMsg = ''
      this.wordLimitErrHeading = '최소한 100단어를 쓰십시오.'
    } else if (this.inputWordCount > 500) {
      //for 500 words limit count
      this.isSubmitBtnDisabled = true
      this.showWordLimitErr = true
      this.wordLimitErrHeading = '단어 수 제한에 도달했습니다.'
      this.wordLimitErrMsg =
        '한 번에 <b>500단어를</b> 입력할 수 있습니다. 단락을 줄여서 다시 시도해 주십시오.'
      // setTimeout(() => {
      //   this.showWordLimitErr = false
      // }, 3000)
    } else if (this.usersCurrentAvailableSessionCount === 0) {
      this.showWordLimitErr = false
      this._dialog.open(DetectionLimitExhaustModalComponent, {
        backdropClass: 'custom-dialog-background',
        width: '490px',
        height: 'auto',
        scrollStrategy: new NoopScrollStrategy(),
        panelClass: "border-radius16",
      })
    } else if (this.showErrorModal) {
      this.clearEditors()
    } else {
      this.showWordLimitErr = false
      this.showLoadingState = true
      //API logic and session count will be deducted here
      let requestBody = {
        text: this.inputText
      }
      this._appService
        .aiDetectionRequest(requestBody, this.setUserId)
        .subscribe({
          complete: () => {},
          next: (response: any) => {
            this.apiResponse = response?.body?.result[0];
            this.showLoadingState = false;
            this.isAIContent = response?.body?.result[0]?.fake
            this.humanContentScore = this.isAIContent
              ? 0
              : response?.body?.result[0].human_score
            this.aiContentScore = this.isAIContent
              ? response?.body?.result[0].ai_score
              : 0
            this.getUserSessionCount()
            document
              .querySelector('#inputEditor')
              .childNodes.forEach((ele: HTMLElement) => {
                setTimeout(() => {
                  if (this.isAIContent) {
                    ele.style.backgroundColor = '#DC262626'
                    ele.style.color = '#DC2626'
                    ele.style.display = 'inline'
                    ele.style.fontWeight = '600'
                    ele.style.lineHeight = '26px'
                  }
                }, 500)
              })
          },
          error: error => {
            console.log('Error is: ', error);
            this.showLoadingState = false
            if (error?.status === 400 || error?.error?.error === 'Rate limit exceeded for today. Try again tomorrow.') {
              this.showWordLimitErr = false;
              this._dialog.open(DetectionLimitExhaustModalComponent, {
                backdropClass: 'custom-dialog-background',
                width: '490px',
                height: 'auto',
                scrollStrategy: new NoopScrollStrategy(),
                panelClass: "border-radius16",
              });
              this.usersCurrentAvailableSessionCount = 0;
            }
            else {
              this.showErrorModal = true;
              this.wordLimitErrMsg = '';
            }
          }
        })
    }
  }

  hideLimitError () {
    this.showWordLimitErr = false
  }

  resetScoreAndInputText () {
    this.isAIContent = false
    this.showErrorModal = false
    this.showLoadingState = false
    this.showWordLimitErr = false
    this.aiContentScore = 0
    this.humanContentScore = 0
  }

  private _attachKeydownEventListener (element: HTMLElement) {
    element.onfocus = (e: any) => {
      if (!element.children.length) {
        let newParagraph = document.createElement('p')
        newParagraph.innerHTML = '<br />'
        element.appendChild(newParagraph)
        window.getSelection().collapse(newParagraph, 0)
        e.preventDefault()
      }

      //TODO: To be added only if we want to disable Trinka's extension on the AI Content Detector's text-editor
      // if(document.querySelector('trinka-extension') && (document.querySelector('trinka-extension') as HTMLElement).style.display !== 'none') (document.querySelector('trinka-extension') as HTMLElement).style.display = 'none';
    }
    element.onblur = (e: any) => {
      if (!element.textContent) {
        element.innerHTML = ''
      }
      e.preventDefault()
    }
  }

  async generateAndSetUserId() {
    const today = new Date();
    const dateKey = `${today.getDate()}${today.getMonth() + 1}${today.getFullYear()}`
    this.setUserId = localStorage.getItem(dateKey)
    if (!this.setUserId) {
      const fingerprintJSResponse = (await (await fpPromise).get());
      this.setUserId = fingerprintJSResponse.visitorId;
      localStorage.setItem(dateKey, this.setUserId);
      this.getUserSessionCount();
    }
  }


  attachPasteEventListener(element: HTMLElement) {
    element.addEventListener('paste', ($event: any) => {
      $event.preventDefault()
      let text = $event.clipboardData.getData('text/plain');
      text = text.replace(/\n{2,}/g, '\n');
      document.execCommand('insertText', false, text);
    });
  }

  getUserSessionCount() {
    if (this.setUserId) {
      this._appService.getAIDetectionSessionCount(this.setUserId).subscribe({
        next: (response: any) => {
          this.usersCurrentAvailableSessionCount = response?.count;
        },
        complete: () => { },
        error: (err: any) => {
          this.usersCurrentAvailableSessionCount = 0;
        }
      })
    } 
    else this.usersCurrentAvailableSessionCount = 10;
  }
}
